import { apiClient } from "./../api/client";
import { API_URLS } from "../api/config";
const { userActivity } = API_URLS;

export const listUserActivitys = (payload) => {
  return apiClient({ url: userActivity.list, data: payload })
    .then((res) => res?.data===null?{}:res?.data===null?{}:res?.data===null?{}:res?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const createUserActivity = (payload) => {
  return apiClient({ url: userActivity.create, data: payload })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err?.data?.message);
    });
};

export const updateUserActivity = (payload) => {
  return apiClient({
    url: userActivity.update + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't update record.");
    });
};

export const softDeleteUserActivity = (payload) => {
  return apiClient({
    url: userActivity.softdelete + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const deleteUserActivity = (payload) => {
  return apiClient({
    url: userActivity.delete + payload.id,
    data: payload,
    method: "DELETE",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getUserActivityCount = () => {
  return apiClient({ url: userActivity.count })
    .then((res) => res.data?.totalRecords || 0)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getUserActivityAggregate = (payload) => {
  return apiClient({ url: userActivity.aggregation, data: payload })
    .then((res) => res.data?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getUserActivityById = (payload) => {
  return apiClient({
    url: userActivity.singlerecord + payload,
    data: { query: { isActive: true, isDeleted: false } },
    method: "GET",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const softDeleteMultipleUserActivity = (payload) => {
  return apiClient({
    url: userActivity.multisoftdelete,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};
